import {
    Component,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild
} from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Observable, ReplaySubject, combineLatest } from 'rxjs';
import { filter, map, takeWhile, withLatestFrom } from 'rxjs/operators';
import clone from 'just-clone';
import { LoggingService } from '../../../shared/services/logging';
import * as fromDataServices from '../../../data-services';
import * as fromShared from '../../../shared';
import * as fromUser from '../../../user-info';
import { ActionsSubject, Store, select } from '@ngrx/store';
import { SelectItem } from '../../../shared';
import * as fromStore from '../../store';
import moment from 'moment';
import { ofType } from '@ngrx/effects';

@Component({
    selector: 'ef-send-invoice-container',
    templateUrl: './send-invoice-container.component.html',
    styleUrls: ['./send-invoice-container.component.scss'],
    standalone: false
})
export class SendInvoiceContainerComponent implements OnInit, OnDestroy {
    selectedErrorWithStatus$: Observable<fromShared.IStatusMessage>;
    process$: Observable<fromShared.Process>;
    public userInfo$: Observable<fromUser.IUserInfo>;
    private sendInvoicesSubject = new ReplaySubject<
        fromDataServices.Invoice.InvoiceModel[]
    >(1);
    SendInvoiceModelDS: EntityCollectionService<fromDataServices.Invoice.InvoiceModel>;
    SendInvoiceModel$: Observable<SelectItem[]>;
    private filterSubject = new ReplaySubject<{
        StartDate: Date;
        EndDate: Date;
        Resend: boolean;
    }>(1);
    loading = false;
    private active = true;
    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private store: Store,
        private dispatcher: ActionsSubject
    ) {
        this.log.verbose({ type: 'SendInvoiceContainerComponent::' });
        this.SendInvoiceModelDS =
            entityServices.getEntityCollectionService<fromDataServices.Invoice.InvoiceModel>(
                fromDataServices.Invoice.entityName
            );
    }
    ngOnInit(): void {
        this.SendInvoiceModelDS.clearCache();
        // this.SendInvoiceModelDS.getAll();
        this.SendInvoiceModel$ = this.SendInvoiceModelDS.entities$.pipe(
            map(items => clone(items)),
            map(items =>
                items.map(item => ({
                    label: `${item.FullName} - ${item.InvoiceNbr}: ${moment(
                        item.InvoiceEnd
                    )
                        .toDate()
                        .toLocaleDateString()} (${item.InvoiceTotal.toLocaleString(
                        Intl.NumberFormat().resolvedOptions().locale,
                        { style: 'currency', currency: 'USD' }
                    )})`,
                    value: {
                        CustJobListID: item.listid,
                        InvoiceNbr: item.InvoiceNbr,
                        InvoiceEnd: item.InvoiceEnd
                    }
                }))
            )
        );
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.setupObservables();
        this.setupSubscriptions();
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    setupObservables(): void {
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.selectedErrorWithStatus$ = this.store.pipe(
            select(fromShared.Errors.selectErrorWithStatus)
        );
    }
    setupSubscriptions(): void {
        this.filterSubject
            .pipe(
                takeWhile(() => this.active),
                filter(value => !!value.StartDate && !!value.EndDate)
            )
            .subscribe(value => {
                this.SendInvoiceModelDS.clearCache();
                this.SendInvoiceModelDS.getWithQuery(value as any);
            });
        this.sendInvoicesSubject
            .pipe(takeWhile(() => this.active))
            .subscribe(items => {
                this.loading = true;
                this.store.dispatch(new fromStore.SendInvoices(items));
            });
        this.dispatcher
            .pipe(
                takeWhile(() => this.active),
                ofType<fromStore.SendInvoicesSuccess>(
                    fromStore.ActionTypes.SendInvoicesSuccess
                ),
                withLatestFrom(this.filterSubject)
            )
            .subscribe(([action, filter]) => {
                this.loading = false;
                if (!filter.Resend) {
                    setTimeout(() => {
                        this.SendInvoiceModelDS.removeManyFromCache(
                            action.payload
                        );
                    }, 3000);
                }
                // this.SendInvoiceModelDS.clearCache();
                // this.SendInvoiceModelDS.getWithQuery(filter as any);
            });
        this.dispatcher
            .pipe(
                takeWhile(() => this.active),
                ofType<fromShared.Errors.SetErrors>(
                    fromShared.Errors.ErrorsSidenavActionTypes.SetErrors
                )
            )
            .subscribe(() => (this.loading = false));
    }
    onFilter(value: { StartDate: Date; EndDate: Date; Resend: boolean }) {
        this.log.verbose({
            type: 'SendInvoiceContainerComponent:onFilter',
            value
        });
        this.filterSubject.next(value);
    }
    onSendInvoices(items: fromDataServices.Invoice.InvoiceModel[]) {
        this.log.verbose({
            type: 'SendInvoiceContainerComponent:onSendInvoices',
            items
        });
        this.sendInvoicesSubject.next(items);
    }
}
